function initJurnal283() {
  const main=document.querySelector('.j283');
  if(!main||main.dataset.j283Ready)return;
  main.dataset.j283Ready='true';
  const filters=main.querySelector('[data-filters]');
  const guides=[...main.querySelectorAll('[data-guide]')];
  const grid=main.querySelector('.j283-grid');
  const count=main.querySelector('[data-count]');
  const empty=main.querySelector('.j283-empty');
  function filter(pillar,history=true){
    let total=0;
    guides.forEach(g=>{g.hidden=Boolean(pillar&&g.dataset.pillar!==pillar);if(!g.hidden)total++;});
    filters?.querySelectorAll('[data-pillar]').forEach(b=>b.setAttribute('aria-pressed',String(b.dataset.pillar===pillar)));
    if(count)count.textContent=total+' '+(total===1?main.dataset.guideSingular:main.dataset.guidePlural);
    if(empty)empty.hidden=total>0;
    grid?.classList.toggle('is-filtered',Boolean(pillar));
    if(history){const u=new URL(location.href);if(pillar)u.searchParams.set('pilon',pillar);else u.searchParams.delete('pilon');window.history.pushState({},'',u);}
  }
  if(filters){
    filters.hidden=false;
    filter(new URL(location.href).searchParams.get('pilon')||'',false);
    filters.addEventListener('click',e=>{const b=e.target.closest('button[data-pillar]');if(b)filter(b.dataset.pillar);});
    window.addEventListener('popstate',()=>filter(new URL(location.href).searchParams.get('pilon')||'',false));
    main.querySelector('[data-reset]')?.addEventListener('click',()=>filter(''));
  }
  main.querySelectorAll('.j283-image').forEach(figure=>{
    const image=figure.querySelector('img');if(!image)return;const status=figure.querySelector('.j283-image-error');
    const originalSrc=image.getAttribute('src'),originalSet=image.getAttribute('srcset');
    let tried=false,returnRetryFocus=false;
    const retryButton=figure.querySelector('[data-image-retry]');
    function ready(){
      if(!image.naturalWidth)return;
      const restoreFocus=returnRetryFocus&&(document.activeElement===document.body||document.activeElement===retryButton||document.activeElement===figure);
      returnRetryFocus=false;
      figure.dataset.imageState='ready';status.hidden=true;
      if(restoreFocus){
        const next=figure.closest('article')?.querySelector('h2 a,h3 a');
        if(next)next.focus({preventScroll:true});
        else{figure.tabIndex=-1;figure.focus({preventScroll:true});}
      }
    }
    function failure(){
      if(!tried&&image.dataset.backup){tried=true;image.removeAttribute('srcset');image.src=image.dataset.backup;return;}
      figure.dataset.imageState='error';status.hidden=false;
      if(returnRetryFocus&&document.activeElement===document.body)retryButton?.focus({preventScroll:true});
      returnRetryFocus=false;
    }
    image.addEventListener('load',ready);image.addEventListener('error',failure);
    if(image.complete){if(image.naturalWidth>0)ready();else failure();}
    function retry(){
      returnRetryFocus=document.activeElement===retryButton;
      tried=false;status.hidden=true;figure.dataset.imageState='loading';
      image.src=originalSrc;if(originalSet)image.srcset=originalSet;
    }
    figure.querySelector('[data-image-retry]')?.addEventListener('click',e=>{e.preventDefault();e.stopPropagation();retry();});
    window.addEventListener('online',()=>{if(figure.dataset.imageState==='error')retry();});
  });
  const video=main.querySelector('video');const toggle=main.querySelector('[data-film-toggle]');
  let pausedByUser=false;
  function updateFilm(){const playing=!video.paused;toggle?.setAttribute('aria-pressed',String(playing));toggle?.setAttribute('aria-label',playing?main.dataset.filmPause:main.dataset.filmPlay);}
  if(video){
    video.muted=true;video.defaultMuted=true;
    video.addEventListener('play',updateFilm);video.addEventListener('pause',updateFilm);
    video.play().catch(updateFilm);
    toggle?.addEventListener('click',()=>{if(video.paused){pausedByUser=false;video.play().catch(updateFilm);}else{pausedByUser=true;video.pause();}});
    document.addEventListener('visibilitychange',()=>{if(!document.hidden&&!pausedByUser)video.play().catch(updateFilm);});
  }
  const toc=main.querySelector('.j283-toc details');
  const narrowReading=matchMedia('(max-width:900px)');
  if(toc){
    toc.open=!narrowReading.matches;
    narrowReading.addEventListener('change',e=>{toc.open=!e.matches;});
  }
  const headings=[...main.querySelectorAll('.j283-body h2[id]')];
  const reader=main.querySelector('.j283-body');
  const progress=main.querySelector('[data-reading-progress]');
  const tocLinks=[...main.querySelectorAll('.j283-toc li a')];
  if(headings.length&&reader){
    let queued=false,lastId='',lastProgress=-1;
    const decode=value=>{try{return decodeURIComponent(value);}catch{return value;}};
    function updateReading(){
      queued=false;
      const threshold=Math.min(innerHeight*.2,120);
      const current=headings.filter(h=>h.getBoundingClientRect().top<=threshold).at(-1)||headings[0];
      if(current.id!==lastId){
        lastId=current.id;
        tocLinks.forEach(a=>{if(decode(a.hash.slice(1))===lastId)a.setAttribute('aria-current','location');else a.removeAttribute('aria-current');});
      }
      if(progress){
        const rect=reader.getBoundingClientRect();
        const start=rect.top+scrollY-innerHeight*.3;
        const end=rect.bottom+scrollY-innerHeight*.8;
        const value=Math.round(Math.max(0,Math.min(1,(scrollY-start)/Math.max(1,end-start)))*100);
        if(value!==lastProgress){lastProgress=value;progress.dataset.value=String(value);progress.style.setProperty('--j-reading',String(value/100));}
      }
    }
    function schedule(){if(!queued){queued=true;requestAnimationFrame(updateReading);}}
    function focusHash(){
      const target=document.getElementById(decode(location.hash.slice(1)));
      if(target&&headings.includes(target))target.focus({preventScroll:true});
      schedule();
    }
    window.addEventListener('scroll',schedule,{passive:true});
    window.addEventListener('resize',schedule,{passive:true});
    window.addEventListener('hashchange',focusHash);
    tocLinks.forEach(a=>a.addEventListener('click',event=>{
      if(event.defaultPrevented||event.button!==0||event.metaKey||event.ctrlKey||event.shiftKey||event.altKey)return;
      const target=document.getElementById(decode(a.hash.slice(1)));
      if(target&&typeof window.tosVerticalScroll==='function'){
        // The shared shell reasserts X after scrolling. In WebKit this cancels
        // its smooth Y animation; chapter navigation must land deterministically.
        event.preventDefault();
        const url=new URL(location.href);url.hash=target.id;
        if(location.hash===url.hash)history.replaceState({},'',url);
        else history.pushState({},'',url);
        window.tosVerticalScroll(target,{block:'start',behavior:'auto'});
      }
      requestAnimationFrame(focusHash);
    }));
    if('ResizeObserver'in window)new ResizeObserver(schedule).observe(reader);
    document.fonts.ready.then(schedule);
    window.addEventListener('pageshow',schedule);
    requestAnimationFrame(focusHash);
  }
}
initJurnal283();
document.addEventListener('shopify:section:load',initJurnal283);
